var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-title"},[_vm._v(" "+_vm._s(_vm.$t(_vm.titleI18nCode))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }